export enum CallStatusEnum {
  TRYING = "TRYING",
  MISSED = "MISSED",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
  UNAVAILABLE = "UNAVAILABLE",
  CANCELED = "CANCELED",
  ACCEPTED = "ACCEPTED"
}
